module.exports = __webpack_public_path__ + "img/BN.46907678.svg";